import { useState, useEffect, useRef } from 'react';

import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

import * as apiComms from '../apiComms';

import Refreshing from '../components/Refreshing';

const ImageCropModal = (props) => {
  
  const imgRef = useRef();
  /**
  const [crop, setCrop] = useState({
    unit: '%', // Can be 'px' or '%'
    x: 25,
    y: 25,
    width: 50,
    height: 50,
    aspect : 1
  });
  **/

  const [ crop, setCrop ] = useState();
  const [ completedCrop, setCompletedCrop ] = useState()
  const [ isRefreshingView, setIsRefreshingView ] = useState(false);
  const [ windowHeight, setWindowHeight ] = useState(100);

  useEffect(() => {
    const FUNCTION = 'useEffect';
                
    setWindowHeight(window.innerHeight);
  }, []);

  const handleOnImageLoadedOLD = () => {

    let aspectRatio = 1;
    if (props.hasOwnProperty('aspect')) {
      aspectRatio = props.aspect;
    }

    const image = imgRef.current;

    const imageWidth = image.width;
    const imageHeight = image.height;
  
    let cropWidth = null;
    let cropHeight = null;
    let x = null;
    let y = null;
    
    if (imageWidth >= imageHeight) {
      cropHeight = ((imageHeight / 100) * 80); // 80%
      cropWidth = cropHeight;
      x = ((imageWidth / 100) * 10); // 10%
      y = ((imageHeight / 100) * 10); // 10%
    }
    else {
      cropWidth = ((imageWidth / 100) * 80); // 80%
      cropHeight = cropWidth;
      x = ((imageWidth / 100) * 10); // 10%
      y = ((imageHeight / 100) * 10); // 10%
    }

    const crop = {
      unit : 'px',
      width : cropWidth,
      height : cropHeight,
      x : x,
      y : y,
      aspect : aspectRatio
    };
    //alert(JSON.stringify(crop));

    setCrop(crop);
    return false;
  };

  const handleOnImageLoaded = () => {
    // Default aspect ratio = 1 (square)
    let aspectRatio = 1;

    if (props.hasOwnProperty("aspect")) {
      // Allow both numeric and string formats like "4:3"
      if (typeof props.aspect === "string" && props.aspect.includes(":")) {
        const [w, h] = props.aspect.split(":").map(Number);
        aspectRatio = w / h;
      } else {
        aspectRatio = Number(props.aspect) || 1;
      }
    }

    const image = imgRef.current;
    const imageWidth = image.width;
    const imageHeight = image.height;

    let cropWidth, cropHeight, x, y;

    // Start with 80% of the smallest dimension
    if (imageWidth >= imageHeight) {
      cropHeight = (imageHeight / 100) * 80;
      cropWidth = cropHeight * aspectRatio;
    } else {
      cropWidth = (imageWidth / 100) * 80;
      cropHeight = cropWidth / aspectRatio;
    }

    // Center crop roughly (10% offset for now)
    x = (imageWidth - cropWidth) / 2;
    y = (imageHeight - cropHeight) / 2;

    const crop = {
      unit: "px",
      width: cropWidth,
      height: cropHeight,
      x,
      y,
      aspect: aspectRatio,
    };

    setCrop(crop);
    return false;
  };

    

  const handleCropPress = async () => {
    const FUNCTION = 'handleCropPress';

    setIsRefreshingView(true);

    try {

      const image = imgRef.current;

      const cropWidth = completedCrop.width;
      const cropHeight = completedCrop.height;

      const canvas = document.createElement('canvas');
      const pixelRatio = window.devicePixelRatio;
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      const ctx = canvas.getContext('2d');

      canvas.width = cropWidth * pixelRatio * scaleX;
      canvas.height = cropHeight * pixelRatio * scaleY;

      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = 'high';

      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        cropWidth * scaleX,
        cropHeight * scaleY,
        0,
        0,
        cropWidth * scaleX,
        cropHeight * scaleY
      );

      const croppedImageBase64 = canvas.toDataURL('image/png');
      //alert('Base64 Image: '+croppedImageBase64);
      
      // Upload image to S3
      const uploadRes = await apiComms.uploadImage(croppedImageBase64);
      if (uploadRes.isErr) {
        alert('Upload Image Error Occured: '+uploadRes.errMsg);
        setIsRefreshingView(false);
      }
      //alert('Upload Res: '+JSON.stringify(uploadRes));
   
      // All Good - pass back the cropped image url to our Add-New Modal 
      const croppedImageUrl = uploadRes.response.image_url;
      props.handleImageCropCompletedEvent(croppedImageUrl);
    }
    catch (e) {
      alert('Upload Image Exception Occured: '+e);
      setIsRefreshingView(false);
    }
      
  };

  return (

    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', zIndex: 20000, width : '100%', height : '100%' }}>
      <div style={{ position : 'absolute', top : 0, bottom : 0, left : 0, right : 0, width : '100%', height : '100%', backgroundColor : 'black', opacity : 0.5 }}></div>
      <div style={{ position : 'absolute', top : 0, bottom : 0, left : 0, right : 0, width : '100%' }}>
        <div className="modal-dialog modal-md" role="document" style={{ width : '80%', backgroundColor : 'white', height : { windowHeight }, maxHeight : { windowHeight } }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">CROP IMAGE</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick = { props.handleCancelPress }
                onPress = { props.handleCancelPress }>
              </button>
            </div>
            <div className="modal-body">
              { isRefreshingView ? (
                <div>
                  <Refreshing message='Uploading Image...' />
                </div>
              ) : null }
              { !isRefreshingView ? (
                <div style={{ display : 'flex', flexDirection : 'column', flexGrow : 10, paddingLeft: 5, paddingRight : 5 }}>
                  <div style={{ marginLeft : 0, marginRight : 0, marginTop : 0 }} className='react-crop-wrapper'>
                    <ReactCrop
                      crop={crop}
                      onChange={c => setCrop(c)}
                      aspect={ props.aspect }
                      onComplete={(c) => setCompletedCrop(c)}
                    >
                      <img src={props.imgsrc} style={{ height : 'auto' }} ref={ imgRef } onLoad={ handleOnImageLoaded } />
                    </ReactCrop>
                  </div>
                </div>
              ) : null }
              <div className="modal-footer">
                { !isRefreshingView ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                      onClick={ props.handleCancelPress }
                      onPress={ props.handleCancelPress }>Cancel</button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-dismiss="modal"
                      onClick={ handleCropPress }
                      onPress={ handleCropPress }>Crop</button>
                  </>
                ) : null }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default ImageCropModal;
        
          


  

  
